export function setAll(state, action) { return action.data }

export function setInMemory(state, action, ...path) {
    if (path.length === 0) return setAll(state, action)
    if (path.length === 1) return {...state, [path[0]]: action.data}

    const [currentKey, ...remainingPath] = path

    return {
        ...state,
        [currentKey]: setInMemory(
            state[currentKey] || {},
            action,
            ...remainingPath
        )
    }
}

export function executeCallback(stateResult, action, reducerName) {
    if (action.callback && ((typeof(action.callback) ===  'function')))
        setTimeout(() => {action.callback(reducerName, stateResult, action)}, 200)
    return stateResult
}